import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField,
  FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Stack, Box
} from '@mui/material';
import { AddCircleOutline } from '@mui/icons-material';
import { CustomField } from '../store/ocrStore';

interface AddCellModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (field: Omit<CustomField, 'id'>) => void;
}

export const AddCellModal: React.FC<AddCellModalProps> = ({ open, onClose, onSave }) => {
  const [label, setLabel] = useState('');
  const [dataType, setDataType] = useState<CustomField['dataType']>('Text');

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!label.trim()) return;

    onSave({ label, dataType });
    setLabel('');
    setDataType('Text');
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ component: 'form', onSubmit: handleSubmit }} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Stack direction="row" spacing={1} alignItems="center">
          <AddCircleOutline />
          <Box>Add Custom Field</Box>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ pt: 1 }}>
          <TextField
            autoFocus
            required
            id="label"
            label="Label / Context"
            placeholder="e.g., Operator Name, Weather Conditions"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            fullWidth
          />
          <FormControl required component="fieldset">
            <FormLabel component="legend">Data Type</FormLabel>
            <RadioGroup row value={dataType} onChange={(e) => setDataType(e.target.value as CustomField['dataType'])}>
              <FormControlLabel value="Text" control={<Radio />} label="Text" />
              <FormControlLabel value="Numeric" control={<Radio />} label="Numeric" />
              <FormControlLabel value="Date" control={<Radio />} label="Date" />
            </RadioGroup>
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">Cancel</Button>
        <Button type="submit" variant="contained">Save Field</Button>
      </DialogActions>
    </Dialog>
  );
};